/**
 * Trạng thái kiểm tra
 */
export default {
    /**
     * Chưa kiểm tra
     */
    NotCheck: 5,
    /**
     * Đang kiểm tra
     */
    Checking: 10,
    /**
     * Đã gửi trả
     */
    Return: 15,
    /**
     * Đã hoàn thành
     */
    Complete: 20,
    /**
     * Cấp dưới yêu cầu thu hồi
     */
    RequestRevoke:25,

    /**
     * đang xử lý gửi trả
     */
    ProcessReturn: 30,
     /**
     * đang xử lý hoàn thành
     */
     ProcessComplete: 35,
     /**
      * Gửi trả không thành công
      */
    FailReturn: 40,
     /**
      * Hoàn thành không thành công
      */
     FailComplete: 45,

    /**
     * Đang hủy hoàn thành
     */
     ProcessCancelComplete: 50,

     /**
      * Hủy hoàn thành thất bại
      */
     FailCancelComplete: 50,
};
